var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.getFirst)?_c('div',{staticClass:"banner"},[_c('router-link',{attrs:{"to":_vm.getFirst.value.imgurl}},[_c('img',{attrs:{"src":_vm.getFirst.value.imgfile}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }